import React, { useState, useEffect } from 'react';
import { Megaphone, ChevronRight } from 'lucide-react';
import { newsAPI } from '../../services/api';
import { newsItems as fallbackNewsItems } from '../../data/mock';

const NewsCintillo = () => {
  const [newsItems, setNewsItems] = useState(fallbackNewsItems);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await newsAPI.getActive();
        if (data && data.length > 0) {
          // Transform API data to match component's expected format
          const transformedNews = data.map(item => ({
            id: item.news_id,
            title: item.title,
            link: item.link,
          }));
          setNewsItems(transformedNews);
        }
      } catch (error) {
        console.error('Error fetching news:', error);
        // Fallback to mock data is already set
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // Duplicate news for seamless scrolling
  const duplicatedNews = [...newsItems, ...newsItems];

  return (
    <div className="relative w-full bg-[#00d4aa] h-9 overflow-hidden z-40">
      <div className="h-full flex items-center">
        <div className="flex items-center gap-2 px-4 bg-[#0a0b0c] h-full">
          <Megaphone className="h-4 w-4 text-[#00d4aa]" />
          <span className="text-[#00d4aa] text-xs font-bold uppercase tracking-wider">News</span>
        </div>
        
        <div className="flex-1 overflow-hidden">
          <div className="animate-scroll-news flex items-center whitespace-nowrap">
            {duplicatedNews.map((item, index) => (
              <a
                key={`${item.id}-${index}`}
                href={item.link}
                className="inline-flex items-center gap-2 px-8 text-[#0a0b0c] text-sm font-medium hover:underline"
              >
                <span>{item.title}</span>
                <ChevronRight className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCintillo;
